export const mapReducer = (state = null, action) => {
    switch (action.type) {
        case 'map':
            return action.payload
        default:
            return state
    }
}
export default mapReducer;